import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import IndexSection from '@/pages/home/components/IndexSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AppSection from '@/pages/home/components/AppSection';
import RankingSection from '@/pages/home/components/RankingSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import MediaSection from '@/pages/home/components/MediaSection';
import ContactSection from '@/pages/home/components/ContactSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <UpdatesSection />
        <AppSection />
        <RankingSection />
        <CommentsSection />
        <AboutSection />
        <CarouselSection />
        <MediaSection />
        <ContactSection />
        <TopicsSection />
        <FaqSection />
        <FeaturesSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}